// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"6d49042a","84":"51dbf087","247":"7d69f7ad","440":"3c5623d8","627":"902aa2c8","738":"c96747d6","834":"519ae414","923":"a3a67ec6"}[chunkId] + ".chunk.js";
};